import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

/**
 * WidgetEvent.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class WidgetEvent extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true },
            widget_event_key: {},
            event: {},
            inventories: {},
            contingents: {},
            all_contingents: {},
            name: {}
        };
    }

    code_url(lang, color, preview = false) {
        return `${window.weezConfig.api.widgetUrl}/ticket/${this.object.widget_event_key}?id_evenement=${this.object.event.id}${lang ? `&locale=${lang}` : ''}${
            color ? `&width_auto=1&color_primary=${color.substring(1)}` : ''
        }${this.object.access_code ? `&code=${this.object.access_code}` : ''}${preview ? '#weez_preview' : ''}`;
    }

    code_href(lang) {
        return this.code_url(lang);
    }

    code_width() {
        return '650';
    }

    code_height() {
        return '600';
    }

    code_resize() {
        return 1;
    }

    hide_power_by_weez() {
        return 0;
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][WidgetEvent] organizationId is mandatory');
        }

        if (!eventId) {
            return `/ticket/organizations/${organizationId}/widget_events`;
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/widget_events`;
    }
}
